/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'angle-brackets-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M7.629 4.5l-6.44 6.439v-.01a1.5 1.5 0 00-.01 2.12l6.44 6.44M16.37 4.5l6.44 6.439-.01-.01c.58.58.58 1.53 0 2.12l-6.44 6.44"/></g>'
  }
})
